/**
 * Нормализует URL изображения для корректного отображения
 * @param {string} url - URL изображения
 * @returns {string} - нормализованный URL
 */
const normalizeImageUrl = (url) => {
  if (!url) return url;
  
  // Если URL относительный, добавляем базовый путь
  if (url.startsWith('/media/')) {
    return `https://law.fishrungames.com${url}`;
  }
  
  // Если URL использует law.fishrungames.com, нормализуем его
  if (url.includes('law.fishrungames.com')) {
    return url
      // Заменяем http:// на https://
      .replace('http://law.fishrungames.com', 'https://law.fishrungames.com')
      // Заменяем api.law.fishrungames.com на law.fishrungames.com
      .replace('https://api.law.fishrungames.com', 'https://law.fishrungames.com')
      .replace('http://api.law.fishrungames.com', 'https://law.fishrungames.com');
  }
  
  return url;
};

/**
 * Получает первое изображение из массива images или возвращает одиночное изображение
 * @param {Object} petition - объект петиции
 * @returns {string|null} - URL первого изображения или null (нормализованный)
 */
export const getFirstPetitionImage = (petition) => {
  // Приоритет: множественные изображения
  if (petition.images && petition.images.length > 0) {
    // Создаем копию массива и сортируем по порядку, возвращаем первое
    const sortedImages = [...petition.images].sort((a, b) => a.order - b.order);
    return normalizeImageUrl(sortedImages[0].image);
  }
  
  // Fallback: одиночное изображение
  if (petition.image) {
    return normalizeImageUrl(petition.image);
  }
  
  return null;
};

/**
 * Получает все изображения петиции
 * @param {Object} petition - объект петиции
 * @returns {Array} - массив изображений (с нормализованными URL)
 */
export const getAllPetitionImages = (petition) => {
  if (petition.images && petition.images.length > 0) {
    return [...petition.images]
      .sort((a, b) => a.order - b.order)
      .map(img => ({
        ...img,
        image: normalizeImageUrl(img.image)
      }));
  }
  
  if (petition.image) {
    return [{ image: normalizeImageUrl(petition.image), order: 0, id: 'single' }];
  }
  
  return [];
};

/**
 * Проверяет, есть ли у петиции изображения
 * @param {Object} petition - объект петиции
 * @returns {boolean} - true если есть изображения
 */
export const hasPetitionImages = (petition) => {
  return (petition.images && petition.images.length > 0) || !!petition.image;
};
